import axios from "axios";

export default function ProductionitemStatusesService() {

  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/production_status",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
